import axios from "axios";
import Route from "../Route";
import AuthenticationAPI from "../services/AuthenticationAPI";

class HttpRequest {

    static statusOk = "OK";
    static statusNo = "NO";

    constructor(baseUrl = Route.APIBaseUrl) {
        if(baseUrl){
            this.api = axios.create({
                baseURL: baseUrl,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            });
        }
    }

    cancelRequest(){
        console.log("Request is cancel")
    }

    /**
     * @param response
     * @return {{code: number, data: []|null, message: string|null, status: string}}
     */
    static parseRequestResponse(response){
        if(typeof response === "string"){
            try {
                response = JSON.parse(response);
            }
            catch (e){
                console.log(response,e);
                response = null;
            }
        }
        let code = 0,
            data = null,
            message = null,
            status = HttpRequest.statusNo
        ;
        if(response){
            code = response.code;
            data = response.data;
            message = response.message;
            if(code === 200){
                status = HttpRequest.statusOk;
            }
        }
        response = {
            code: code,
            status: status,
            data: data,
            message: message,
        };
        return response;
    }

    /**
     * @param url
     * @param method
     * @param params
     * @param body
     * @param headers
     * @return {Promise<{code: int, status: string data: [], message: string}>}
     */
    request(url, method, params, body, headers = null){
        const _self = this;
        return new Promise(function (resolve, reject) {
            const
                accessToken = AuthenticationAPI.getCurrentUser() && AuthenticationAPI.user.hasOwnProperty("accessToken") ? AuthenticationAPI.user.accessToken : "",
                xAccessToken = accessToken ? {"X-Access-Token" : accessToken} : null
            ;
            headers = headers && xAccessToken ? {...headers, ...xAccessToken} : (xAccessToken ? xAccessToken : headers);
            _self.api.request({
                url: url,
                method: method,
                params: params,
                data: body,
                headers: headers
            }).then(response => {
                const value = HttpRequest.parseRequestResponse(response.data);
                AuthenticationAPI.checkAccess(value);
                resolve(value);
            }).catch(error => {
                reject(error);
            });
        })
    }
}

export default HttpRequest;